export const getLocalStorageItem = (key: string): string =>
  localStorage.getItem(key) ?? '{}';

export const setLocalStorageItem = (key: string, value: string): void =>
  localStorage.setItem(key, value);
